import React, { useEffect, useState } from "react";
import ticketStore from "../../Stores/TicketStores";
import TicketConstants from "../../Constants/TicketConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import { useLanguageContext } from "../../Context/LanguageContext";
import { toast } from "react-toastify";
export default function DetailsModal({
  setTicketID,
  showButton,
  setIsDisable,
}) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [values, setValue] = useState(null);
  const [extraInfo, setExtraInfo] = useState(null);
  const [isImageShow, setIsImageShow] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [showDiv, setShowDiv] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [ticketQuestionAns, setTicketQuestionAns] = useState(null);
  const [_response, setResponse] = React.useState(null);
  const headers = [
    { key: "title", label: localization.manageTickeTitle, value: "" },
    { key: "createdOn", label: localization.createdOn, value: "" },
    { key: "priority", label: localization.priority, value: "" },
    { key: "status", label: localization.ticketStatus, value: "" },
    { key: "files", label: localization.inspectionImage, value: "" },
    {
      key: "description",
      label: localization.manageTicketDesc,
      value: "",
    },
    {
      key: "category",
      label: localization.category,
      value: "",
    },
    {
      key: "name",
      label: localization.createdBy,
      value: "",
    },
    {
      key: "emailAddresses",
      label: localization.email,
      value: "",
    },
    {
      key: "phoneNumber",
      label: localization.phoneNumber,
      value: "",
    },
  ];

  useEffect(() => {
    if (_response) {
      let image = [];
      headers.map((item) => {
        if (item.key !== "files") {
          if (item.key.toLowerCase() === "priority") {
            item.value =
              _response[item.key].toLowerCase() === "low"
                ? localization.low
                : _response[item.key].toLowerCase() === "medium"
                  ? localization.medium
                  : localization.high;
          } else if (item.key.toLowerCase() === "status") {
            item.value =
              _response[item.key].toLowerCase() === "close"
                ? localization.close
                : _response[item.key].toLowerCase() === "open"
                  ? localization.openTicket
                  : localization.inprogress;
          } else {
            item.value = _response[item.key];
          }
        }
      });
      _response["files"].map((item) => {
        image.push(`data:image/jpg;base64,${item.filecontent}`);
      });
      if (image.length > 0) {
        setImageSrc(image);
      }
      setTicketID(_response.id);
      setValue(headers);
      setExtraInfo(_response["extraInformation"]);
      setTicketQuestionAns(_response["questionAnswer"]);
      showButton(true);
      setShowDiv(true);
      setIsDisable(_response.status.toLowerCase() === "close" ? false : true);
      setGlobalSpinner(false);
    }
  }, [_response]);

  useEffect(() => {
    function getTicketDetailsSuccess() {
      var res = ticketStore.getResult();
      if (res) {
        setResponse(res);
      } else {
        showButton(false);
        setGlobalSpinner(false);
      }
    }
    function getTicketDetailsFailure() {
      var res = ticketStore.getResult();
      toast.error(res);
      showButton(false);
      setGlobalSpinner(false);
    }
    ticketStore.addChangeListener(
      TicketConstants.GET_TICKET_DETAILS_SUCCESS,
      getTicketDetailsSuccess,
    );
    ticketStore.addChangeListener(
      TicketConstants.GET_TICKET_DETAILS_FAILURE,
      getTicketDetailsFailure,
    );
    return () => {
      ticketStore.removeChangeListener(
        TicketConstants.GET_TICKET_DETAILS_SUCCESS,
        getTicketDetailsSuccess,
      );
      ticketStore.removeChangeListener(
        TicketConstants.GET_TICKET_DETAILS_FAILURE,
        getTicketDetailsFailure,
      );
    };
  }, []);

  function handleLightBox(e, _value) {
    e.preventDefault();
    setSelectedImage(_value);
    setIsImageShow(true);
  }
  return (
    showDiv && (
      <React.Fragment>
        {values &&
          values.map((item, index) => {
            if (item.key === "files") {
              return (
                <div
                  className="row  ml-auto mr-auto mb-0   p-3  fontStyle"
                  key={index}
                >
                  <div className="col-6 pl-0 pr-0">{item.label}</div>
                  <div className="col-6 pl-0 pr-0">
                    {imageSrc
                      ? imageSrc.map((item, _index) => (
                          <img
                            className="imageDiv cursorPoint mr-2"
                            alt="not Found"
                            src={item}
                            onClick={(e) => handleLightBox(e, _index)}
                          />
                        ))
                      : localization.noImageMsg}
                  </div>
                </div>
              );
            } else {
              return (
                <>
                  <div
                    className="row  ml-auto mr-auto mb-0   p-3  fontStyle"
                    key={index}
                  >
                    <div className="col-6 pl-0 pr-0">{item.label}</div>
                    <div className="col-6 pl-0 pr-0">{item.value}</div>
                  </div>
                  {item.key == "status" &&
                    _response[item.key].toLowerCase() === "close" && (
                      <div
                        className="row  ml-auto mr-auto mb-0   p-3  fontStyle"
                        key={index}
                      >
                        <div className="col-6 pl-0 pr-0">
                          {localization.closeReason}
                        </div>
                        <div className="col-6 pl-0 pr-0">
                          {_response["closeReason"]}
                        </div>
                      </div>
                    )}
                </>
              );
            }
          })}
        {extraInfo &&
          extraInfo.map((item, index) => (
            <div className="row  ml-auto mr-auto   p-3  fontStyle" key={index}>
              <div className="col-6 pl-0 pr-0">{item.id}</div>
              <div className="col-6 pl-0 pr-0">{item.text}</div>
            </div>
          ))}

        {ticketQuestionAns && ticketQuestionAns.length > 0 && (
          <>
            <hr></hr>
            <div className="row  ml-auto mr-auto   p-3  fontStyle">
              <div className="col-6 pl-0 pr-0">
                <b>{localization.frage}</b>
              </div>
              <div className="col-6 pl-0 pr-0">
                <b>{localization.antwort}</b>
              </div>
            </div>

            {ticketQuestionAns.map((item, index) => (
              <div className="row  ml-auto mr-auto   p-3  fontStyle">
                <div className="col-6 pl-0 pr-0">
                  {index + 1}.{item.frage}
                </div>
                <div className="col-6 pl-0 pr-0">{item.antwort}</div>
              </div>
            ))}
          </>
        )}

        {isImageShow &&
          (imageSrc.length === 1 ? (
            <Lightbox
              allowReset={false}
              onClose={() => {
                setIsImageShow(false);
              }}
              image={imageSrc[0]}
            ></Lightbox>
          ) : (
            <Lightbox
              allowReset={false}
              onClose={() => {
                setIsImageShow(false);
              }}
              images={imageSrc}
              startIndex={selectedImage}
            ></Lightbox>
          ))}
      </React.Fragment>
    )
  );
}
